const geojsonData = {
  type: "FeatureCollection",

  features: [
    {
      type: "Feature",
      id: "sm5e023386",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.002275415, 40.720743383],
            [-74.002453739, 40.720955929],
            [-74.002652223, 40.720996585],
            [-74.00309747, 40.720781105],
            [-74.00309747, 40.720618477],
            [-74.002934076, 40.720425958],
            [-74.002275415, 40.720743383],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB01",
      },
    },
    {
      type: "Feature",
      id: "smb0efed30",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.002696354, 40.720145862],
            [-74.002459104, 40.71986632],
            [-74.002255256, 40.719963898],
            [-74.001826103, 40.720207841],
            [-74.002039634, 40.720462353],
            [-74.002696354, 40.720145862],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB03",
      },
    },
    {
      type: "Feature",
      id: "sm4fa20fb5",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.002039634, 40.720462353],
            [-74.002275415, 40.720743383],
            [-74.002934076, 40.720425958],
            [-74.002696354, 40.720145862],
            [-74.002039634, 40.720462353],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB02",
      },
    },
    {
      type: "Feature",
      id: "smc29c519b",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.001611972, 40.718864662],
            [-74.001300388, 40.718492087],
            [-74.000833684, 40.718638457],
            [-74.001112146, 40.719104781],
            [-74.001611972, 40.718864662],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB07",
      },
    },
    {
      type: "Feature",
      id: "smdc911161",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.001112146, 40.719104781],
            [-74.001115316, 40.719110089],
            [-74.001347853, 40.719491074],
            [-74.001909994, 40.71922102],
            [-74.001611972, 40.718864662],
            [-74.001112146, 40.719104781],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB06",
      },
    },
    {
      type: "Feature",
      id: "smbcb7670e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.001347853, 40.719491074],
            [-74.001555261, 40.719830886],
            [-74.002172176, 40.719534521],
            [-74.001909994, 40.71922102],
            [-74.001347853, 40.719491074],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB05",
      },
    },
    {
      type: "Feature",
      id: "sm1d0ebd67",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.001555261, 40.719830886],
            [-74.001745636, 40.72014279],
            [-74.00240546, 40.719813466],
            [-74.002172176, 40.719534521],
            [-74.001555261, 40.719830886],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB04",
      },
    },
    {
      type: "Feature",
      id: "sm0f18bfd6",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.002857527, 40.719082988],
            [-74.002238292, 40.719383881],
            [-74.002488607, 40.719687428],
            [-74.002488607, 40.719687428],
            [-74.003110879, 40.719382496],
            [-74.002857527, 40.719082988],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB11",
      },
    },
    {
      type: "Feature",
      id: "sm515034bb",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.002238292, 40.719383881],
            [-74.002857527, 40.719082988],
            [-74.002598155, 40.718776361],
            [-74.001983574, 40.719074994],
            [-74.002238292, 40.719383881],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB10",
      },
    },
    {
      type: "Feature",
      id: "sm9f45b02f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.001983574, 40.719074994],
            [-74.002598155, 40.718776361],
            [-74.002345803, 40.718478032],
            [-74.001731332, 40.718769108],
            [-74.001983574, 40.719074994],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB09",
      },
    },
    {
      type: "Feature",
      id: "smee1709bd",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.001731332, 40.718769108],
            [-74.002345803, 40.718478032],
            [-74.002123826, 40.718215611],
            [-74.001469367, 40.718451429],
            [-74.001731332, 40.718769108],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB08",
      },
    },
    {
      type: "Feature",
      id: "smc12fb3d4",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.002805499, 40.720042735],
            [-74.003432741, 40.719737767],
            [-74.003169889, 40.719427221],
            [-74.003169889, 40.719427221],
            [-74.002552981, 40.719736219],
            [-74.002805499, 40.720042735],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB12",
      },
    },
    {
      type: "Feature",
      id: "smc3505b85",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.003681279, 40.720031401],
            [-74.003049302, 40.72033867],
            [-74.003239626, 40.720569691],
            [-74.003432745, 40.720614414],
            [-74.003856534, 40.72041926],
            [-74.00389945, 40.720289157],
            [-74.003681279, 40.720031401],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB14",
      },
    },
    {
      type: "Feature",
      id: "sm21227b1b",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.003049302, 40.72033867],
            [-74.003681279, 40.720031401],
            [-74.003432741, 40.719737767],
            [-74.002805499, 40.720042735],
            [-74.003049302, 40.72033867],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB13",
      },
    },
    {
      type: "Feature",
      id: "sm59e5d75a",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.004273336, 40.71930767],
            [-74.004714842, 40.719101958],
            [-74.004714842, 40.718943392],
            [-74.004478179, 40.718664268],
            [-74.003948436, 40.718917978],
            [-74.004273336, 40.71930767],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB41",
      },
    },
    {
      type: "Feature",
      id: "sm8b2aead2",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.003948436, 40.718917978],
            [-74.003352545, 40.719203368],
            [-74.003556128, 40.719447549],
            [-74.003792163, 40.719463812],
            [-74.003990646, 40.719341839],
            [-74.004060383, 40.719406891],
            [-74.004273336, 40.71930767],
            [-74.003948436, 40.718917978],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB40",
      },
    },
    {
      type: "Feature",
      id: "smb2f82d22",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.00362528, 40.718591836],
            [-74.003066008, 40.718859689],
            [-74.003352545, 40.719203368],
            [-74.003911817, 40.718935516],
            [-74.00362528, 40.718591836],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB39",
      },
    },
    {
      type: "Feature",
      id: "sm8f50758d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.003911817, 40.718935516],
            [-74.004478179, 40.718664268],
            [-74.004188184, 40.718322242],
            [-74.00362528, 40.718591836],
            [-74.003911817, 40.718935516],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB42",
      },
    },
    {
      type: "Feature",
      id: "smd595ff53",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.003338627, 40.718248883],
            [-74.002779872, 40.71851649],
            [-74.003066008, 40.718859689],
            [-74.003624762, 40.718592084],
            [-74.003338627, 40.718248883],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB38",
      },
    },
    {
      type: "Feature",
      id: "sm0e280d61",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.003624762, 40.718592084],
            [-74.004188184, 40.718322242],
            [-74.003898596, 40.717980693],
            [-74.003338627, 40.718248883],
            [-74.003624762, 40.718592084],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB43",
      },
    },
    {
      type: "Feature",
      id: "sm8b536fd7",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.003003803, 40.717931165],
            [-74.002451057, 40.718122098],
            [-74.002779872, 40.71851649],
            [-74.003288648, 40.718272819],
            [-74.003003803, 40.717931165],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB37",
      },
    },
    {
      type: "Feature",
      id: "smd6b9962a",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.003288648, 40.718272819],
            [-74.003898596, 40.717980693],
            [-74.003663417, 40.717703315],
            [-74.003663417, 40.717703315],
            [-74.003003803, 40.717931165],
            [-74.003288648, 40.718272819],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB44",
      },
    },
    {
      type: "Feature",
      id: "smf5aba72c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.003626907, 40.715453029],
            [-74.003368373, 40.7151499],
            [-74.00279438, 40.715296277],
            [-74.003086416, 40.71571786],
            [-74.003626907, 40.715453029],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB58",
      },
    },
    {
      type: "Feature",
      id: "sm479156d6",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.003086416, 40.71571786],
            [-74.003333869, 40.716075082],
            [-74.003914714, 40.715790479],
            [-74.003626907, 40.715453029],
            [-74.003086416, 40.71571786],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB57",
      },
    },
    {
      type: "Feature",
      id: "sm19cc1d48",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.003333869, 40.716075082],
            [-74.003564244, 40.716407648],
            [-74.004182658, 40.716104639],
            [-74.003914714, 40.715790479],
            [-74.003333869, 40.716075082],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB56",
      },
    },
    {
      type: "Feature",
      id: "sm303c7245",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.003564244, 40.716407648],
            [-74.003782513, 40.716722736],
            [-74.004436521, 40.716402288],
            [-74.004182658, 40.716104639],
            [-74.003564244, 40.716407648],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB55",
      },
    },
    {
      type: "Feature",
      id: "smbce0e87e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.003782513, 40.716722736],
            [-74.003994367, 40.717028563],
            [-74.004682924, 40.716691188],
            [-74.004436521, 40.716402288],
            [-74.003782513, 40.716722736],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB54",
      },
    },
    {
      type: "Feature",
      id: "sm49a1add2",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.003994367, 40.717028563],
            [-74.004001917, 40.717039462],
            [-74.004222315, 40.717302381],
            [-74.004918337, 40.716967202],
            [-74.004682924, 40.716691188],
            [-74.003994367, 40.717028563],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB53",
      },
    },
    {
      type: "Feature",
      id: "sm1ee2ff64",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.004222315, 40.717302381],
            [-74.004457281, 40.717582678],
            [-74.005156211, 40.7172461],
            [-74.004918337, 40.716967202],
            [-74.004222315, 40.717302381],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB52",
      },
    },
    {
      type: "Feature",
      id: "sma37c6765",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.004457281, 40.717582678],
            [-74.004699987, 40.717872207],
            [-74.005401921, 40.717534184],
            [-74.005156211, 40.7172461],
            [-74.004457281, 40.717582678],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB51",
      },
    },
    {
      type: "Feature",
      id: "smda1ae87d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.004699987, 40.717872207],
            [-74.004939152, 40.71815751],
            [-74.005644046, 40.717818064],
            [-74.005401921, 40.717534184],
            [-74.004699987, 40.717872207],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB50",
      },
    },
    {
      type: "Feature",
      id: "smd6d3f3a7",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.004939152, 40.71815751],
            [-74.005179833, 40.718444621],
            [-74.005887705, 40.718103741],
            [-74.005644046, 40.717818064],
            [-74.004939152, 40.71815751],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB49",
      },
    },
    {
      type: "Feature",
      id: "sm63905954",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.005179833, 40.718444621],
            [-74.005425261, 40.718737393],
            [-74.006061311, 40.718431101],
            [-74.006055947, 40.718300995],
            [-74.005887705, 40.718103741],
            [-74.005179833, 40.718444621],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB48",
      },
    },
    {
      type: "Feature",
      id: "smbe410111",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.004622662, 40.718499298],
            [-74.004945512, 40.718882406],
            [-74.005090352, 40.718898669],
            [-74.005425261, 40.718737393],
            [-74.005051601, 40.718291652],
            [-74.004622662, 40.718499298],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB47",
      },
    },
    {
      type: "Feature",
      id: "sm47d255a4",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.005051601, 40.718291652],
            [-74.004694157, 40.717865252],
            [-74.004263879, 40.718073548],
            [-74.004622662, 40.718499298],
            [-74.005051601, 40.718291652],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB46",
      },
    },
    {
      type: "Feature",
      id: "sm125d613c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.004694157, 40.717865252],
            [-74.004367487, 40.717460369],
            [-74.004292385, 40.717486797],
            [-74.003883356, 40.717621997],
            [-74.003883356, 40.717621997],
            [-74.004263879, 40.718073548],
            [-74.004694157, 40.717865252],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB45",
      },
    },
    {
      type: "Feature",
      id: "sm9228cae1",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.005443741, 40.715173535],
            [-74.005199434, 40.714861475],
            [-74.004566144, 40.7151682],
            [-74.004823782, 40.715473803],
            [-74.005443741, 40.715173535],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB77",
      },
    },
    {
      type: "Feature",
      id: "smfeb1374c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.004823782, 40.715473803],
            [-74.005080311, 40.715778088],
            [-74.005686997, 40.715484251],
            [-74.005443741, 40.715173535],
            [-74.004823782, 40.715473803],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB76",
      },
    },
    {
      type: "Feature",
      id: "smfb559495",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.005080311, 40.715778088],
            [-74.005342657, 40.716089273],
            [-74.005935769, 40.715802011],
            [-74.005686997, 40.715484251],
            [-74.005080311, 40.715778088],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB75",
      },
    },
    {
      type: "Feature",
      id: "smcb355bbb",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.005342657, 40.716089273],
            [-74.005608046, 40.716404066],
            [-74.006199393, 40.716119163],
            [-74.005968774, 40.715844169],
            [-74.005935769, 40.715802011],
            [-74.005342657, 40.716089273],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB74",
      },
    },
    {
      type: "Feature",
      id: "sma10fe8c9",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.005608046, 40.716404066],
            [-74.005870788, 40.716715717],
            [-74.006461154, 40.716431289],
            [-74.006199393, 40.716119163],
            [-74.005608046, 40.716404066],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB73",
      },
    },
    {
      type: "Feature",
      id: "smc58263a7",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.005870788, 40.716715717],
            [-74.006137082, 40.717031581],
            [-74.006726453, 40.716747633],
            [-74.006461154, 40.716431289],
            [-74.005870788, 40.716715717],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB72",
      },
    },
    {
      type: "Feature",
      id: "sme797d0b8",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.006137082, 40.717031581],
            [-74.006402039, 40.717345857],
            [-74.006989529, 40.717061324],
            [-74.006726453, 40.716747633],
            [-74.006137082, 40.717031581],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB71",
      },
    },
    {
      type: "Feature",
      id: "sm46fdff49",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.006402039, 40.717345857],
            [-74.006682907, 40.717679005],
            [-74.00726935, 40.717394981],
            [-74.006989529, 40.717061324],
            [-74.006402039, 40.717345857],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB70",
      },
    },
    {
      type: "Feature",
      id: "sm57be2530",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.006682907, 40.717679005],
            [-74.006950709, 40.717996653],
            [-74.007466786, 40.717743972],
            [-74.007480197, 40.717646392],
            [-74.00726935, 40.717394981],
            [-74.006682907, 40.717679005],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB69",
      },
    },
    {
      type: "Feature",
      id: "sm36d4fad8",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.006047313, 40.717962171],
            [-74.006267839, 40.718223743],
            [-74.006428771, 40.718252204],
            [-74.006950709, 40.717996653],
            [-74.006668143, 40.717661494],
            [-74.006047313, 40.717962171],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB68",
      },
    },
    {
      type: "Feature",
      id: "sm8109f00e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.006668143, 40.717661494],
            [-74.006405797, 40.717350316],
            [-74.005784967, 40.717650996],
            [-74.006047313, 40.717962171],
            [-74.006668143, 40.717661494],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB67",
      },
    },
    {
      type: "Feature",
      id: "sm0ad46c2e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.006405797, 40.717350316],
            [-74.006136422, 40.7170308],
            [-74.005515591, 40.71733148],
            [-74.005784967, 40.717650996],
            [-74.006405797, 40.717350316],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB66",
      },
    },
    {
      type: "Feature",
      id: "smea530429",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.006136422, 40.7170308],
            [-74.005867451, 40.716711761],
            [-74.00524662, 40.717012443],
            [-74.005515591, 40.71733148],
            [-74.006136422, 40.7170308],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB65",
      },
    },
    {
      type: "Feature",
      id: "sm4dd5c610",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.005867451, 40.716711761],
            [-74.005608216, 40.716404268],
            [-74.004987385, 40.716704952],
            [-74.00524662, 40.717012443],
            [-74.005867451, 40.716711761],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB64",
      },
    },
    {
      type: "Feature",
      id: "smebe83b25",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.005608216, 40.716404268],
            [-74.005335326, 40.716080578],
            [-74.004714495, 40.716381264],
            [-74.004987385, 40.716704952],
            [-74.005608216, 40.716404268],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB63",
      },
    },
    {
      type: "Feature",
      id: "smf8498733",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.005335326, 40.716080578],
            [-74.005092997, 40.715793137],
            [-74.004472166, 40.716093824],
            [-74.004714495, 40.716381264],
            [-74.005335326, 40.716080578],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB62",
      },
    },
    {
      type: "Feature",
      id: "sm06466fd4",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.005092997, 40.715793137],
            [-74.004820511, 40.715469923],
            [-74.00419968, 40.715770611],
            [-74.004472166, 40.716093824],
            [-74.005092997, 40.715793137],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB61",
      },
    },
    {
      type: "Feature",
      id: "smef9fbecc",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.004820511, 40.715469923],
            [-74.004566144, 40.7151682],
            [-74.003945313, 40.715468889],
            [-74.00419968, 40.715770611],
            [-74.004820511, 40.715469923],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB60",
      },
    },
    {
      type: "Feature",
      id: "smc0a646e9",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.004205421, 40.714902541],
            [-74.003604406, 40.715064514],
            [-74.003945313, 40.715468889],
            [-74.004469034, 40.715215233],
            [-74.004205421, 40.714902541],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB59",
      },
    },
    {
      type: "Feature",
      id: "sm6cbac994",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.004469034, 40.715215233],
            [-74.005199434, 40.714861475],
            [-74.005052799, 40.714674174],
            [-74.004205421, 40.714902541],
            [-74.004469034, 40.715215233],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB78",
      },
    },
    {
      type: "Feature",
      id: "sm2a960354",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.007066606, 40.714772625],
            [-74.006814724, 40.71446079],
            [-74.00623148, 40.714734892],
            [-74.006485676, 40.715045638],
            [-74.007066606, 40.714772625],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB95",
      },
    },
    {
      type: "Feature",
      id: "smd4bca937",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.006485676, 40.715045638],
            [-74.006761965, 40.715383392],
            [-74.007340381, 40.715111562],
            [-74.007066606, 40.714772625],
            [-74.006485676, 40.715045638],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB94",
      },
    },
    {
      type: "Feature",
      id: "sm00f4dbf6",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.006761965, 40.715383392],
            [-74.007018553, 40.715697061],
            [-74.007594634, 40.715426329],
            [-74.007340381, 40.715111562],
            [-74.006761965, 40.715383392],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB93",
      },
    },
    {
      type: "Feature",
      id: "smd1fe3170",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.007018553, 40.715697061],
            [-74.007282253, 40.716019422],
            [-74.00786151, 40.715747199],
            [-74.007610282, 40.715445701],
            [-74.007594634, 40.715426329],
            [-74.007018553, 40.715697061],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB92",
      },
    },
    {
      type: "Feature",
      id: "sm25a04df2",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.007282253, 40.716019422],
            [-74.007550758, 40.716347655],
            [-74.00813361, 40.716073744],
            [-74.00786151, 40.715747199],
            [-74.007282253, 40.716019422],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB91",
      },
    },
    {
      type: "Feature",
      id: "sm1fafe968",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.007550758, 40.716347655],
            [-74.007809653, 40.716664139],
            [-74.008395972, 40.716388601],
            [-74.00813361, 40.716073744],
            [-74.007550758, 40.716347655],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB90",
      },
    },
    {
      type: "Feature",
      id: "sme69c518d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.007809653, 40.716664139],
            [-74.008077967, 40.716992136],
            [-74.008667878, 40.71671491],
            [-74.008395972, 40.716388601],
            [-74.007809653, 40.716664139],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB89",
      },
    },
    {
      type: "Feature",
      id: "sm481dbaf9",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.008077967, 40.716992136],
            [-74.008362444, 40.717339888],
            [-74.008870922, 40.71709648],
            [-74.008897744, 40.716990767],
            [-74.008667878, 40.71671491],
            [-74.008077967, 40.716992136],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB88",
      },
    },
    {
      type: "Feature",
      id: "sm6ee73ce6",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.00747858, 40.717285024],
            [-74.007706843, 40.717564058],
            [-74.007851683, 40.717584387],
            [-74.008362444, 40.717339888],
            [-74.008084592, 40.717000233],
            [-74.00747858, 40.717285024],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB87",
      },
    },
    {
      type: "Feature",
      id: "sme9b10604",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.008084592, 40.717000233],
            [-74.00781061, 40.716665307],
            [-74.007204598, 40.7169501],
            [-74.00747858, 40.717285024],
            [-74.008084592, 40.717000233],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB86",
      },
    },
    {
      type: "Feature",
      id: "sm67b3522c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.00781061, 40.716665307],
            [-74.007548254, 40.716344593],
            [-74.006942242, 40.716629387],
            [-74.007204598, 40.7169501],
            [-74.00781061, 40.716665307],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB85",
      },
    },
    {
      type: "Feature",
      id: "smc8bd861b",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.007548254, 40.716344593],
            [-74.0072834, 40.716020824],
            [-74.006677389, 40.716305619],
            [-74.006942242, 40.716629387],
            [-74.007548254, 40.716344593],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB84",
      },
    },
    {
      type: "Feature",
      id: "sm648a21fe",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.0072834, 40.716020824],
            [-74.007025658, 40.715705747],
            [-74.006419647, 40.715990543],
            [-74.006677389, 40.716305619],
            [-74.0072834, 40.716020824],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB83",
      },
    },
    {
      type: "Feature",
      id: "sm64b4ccbe",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.007025658, 40.715705747],
            [-74.006756481, 40.715376689],
            [-74.00615047, 40.715661486],
            [-74.006419647, 40.715990543],
            [-74.007025658, 40.715705747],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB82",
      },
    },
    {
      type: "Feature",
      id: "sme0eeb0b3",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.006756481, 40.715376689],
            [-74.006490955, 40.715052093],
            [-74.005884944, 40.715336891],
            [-74.00615047, 40.715661486],
            [-74.006756481, 40.715376689],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB81",
      },
    },
    {
      type: "Feature",
      id: "sm9f3c2d2f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.006490955, 40.715052093],
            [-74.00623148, 40.714734892],
            [-74.005625469, 40.715019692],
            [-74.005884944, 40.715336891],
            [-74.006490955, 40.715052093],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB80",
      },
    },
    {
      type: "Feature",
      id: "smc57b955c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.005856544, 40.714452552],
            [-74.005282128, 40.714599967],
            [-74.005625469, 40.715019692],
            [-74.006127482, 40.714783767],
            [-74.005856544, 40.714452552],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB79",
      },
    },
    {
      type: "Feature",
      id: "smac3d1a0b",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.006127482, 40.714783767],
            [-74.006814724, 40.71446079],
            [-74.00664469, 40.714250285],
            [-74.005856544, 40.714452552],
            [-74.006127482, 40.714783767],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB96",
      },
    },
    {
      type: "Feature",
      id: "sm4c377ad3",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.009170171, 40.714622321],
            [-74.008928246, 40.714329557],
            [-74.008239678, 40.714654546],
            [-74.008480584, 40.714947789],
            [-74.009170171, 40.714622321],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB112",
      },
    },
    {
      type: "Feature",
      id: "sm3a9b8a0c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.008480584, 40.714947789],
            [-74.008707214, 40.715223654],
            [-74.009397759, 40.714897735],
            [-74.009170171, 40.714622321],
            [-74.008480584, 40.714947789],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB111",
      },
    },
    {
      type: "Feature",
      id: "sm7f4a0995",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.008707214, 40.715223654],
            [-74.008938658, 40.715505377],
            [-74.009630181, 40.715178998],
            [-74.009397759, 40.714897735],
            [-74.008707214, 40.715223654],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB110",
      },
    },
    {
      type: "Feature",
      id: "sm302ab2c3",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.008938658, 40.715505377],
            [-74.00916111, 40.715776153],
            [-74.009853573, 40.715449331],
            [-74.009630181, 40.715178998],
            [-74.008938658, 40.715505377],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB109",
      },
    },
    {
      type: "Feature",
      id: "smfce219e3",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.00916111, 40.715776153],
            [-74.009387105, 40.716051241],
            [-74.010080523, 40.71572397],
            [-74.009853573, 40.715449331],
            [-74.00916111, 40.715776153],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB108",
      },
    },
    {
      type: "Feature",
      id: "sme6bd457b",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.009387105, 40.716051241],
            [-74.009622728, 40.716338047],
            [-74.010317142, 40.716010308],
            [-74.010080523, 40.71572397],
            [-74.009387105, 40.716051241],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB107",
      },
    },
    {
      type: "Feature",
      id: "sm5f35e5f0",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.009622728, 40.716338047],
            [-74.009858871, 40.716625485],
            [-74.010477562, 40.716323953],
            [-74.010485609, 40.716214173],
            [-74.010317142, 40.716010308],
            [-74.009622728, 40.716338047],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB106",
      },
    },
    {
      type: "Feature",
      id: "sm7822ec0e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.008917492, 40.716667805],
            [-74.009117682, 40.716911479],
            [-74.009267886, 40.716913512],
            [-74.009858871, 40.716625485],
            [-74.009620901, 40.716335822],
            [-74.008917492, 40.716667805],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB105",
      },
    },
    {
      type: "Feature",
      id: "smdc03c297",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.009620901, 40.716335822],
            [-74.00938764, 40.716051891],
            [-74.008684231, 40.716383875],
            [-74.008917492, 40.716667805],
            [-74.009620901, 40.716335822],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB104",
      },
    },
    {
      type: "Feature",
      id: "sm08de1ece",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.00938764, 40.716051891],
            [-74.009162191, 40.715777468],
            [-74.008458782, 40.716109453],
            [-74.008684231, 40.716383875],
            [-74.00938764, 40.716051891],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB103",
      },
    },
    {
      type: "Feature",
      id: "sma5fc6a3c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.009162191, 40.715777468],
            [-74.008937377, 40.715503816],
            [-74.008233968, 40.715835803],
            [-74.008458782, 40.716109453],
            [-74.009162191, 40.715777468],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB102",
      },
    },
    {
      type: "Feature",
      id: "sm14b0c40c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.008937377, 40.715503816],
            [-74.008701119, 40.715216233],
            [-74.00799771, 40.715548222],
            [-74.008233968, 40.715835803],
            [-74.008937377, 40.715503816],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB101",
      },
    },
    {
      type: "Feature",
      id: "sma54b410a",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.008701119, 40.715216233],
            [-74.0084823, 40.714949877],
            [-74.007778891, 40.715281867],
            [-74.00799771, 40.715548222],
            [-74.008701119, 40.715216233],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB100",
      },
    },
    {
      type: "Feature",
      id: "sm25583de2",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.0084823, 40.714949877],
            [-74.008239678, 40.714654546],
            [-74.007536269, 40.714986537],
            [-74.007778891, 40.715281867],
            [-74.0084823, 40.714949877],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB99",
      },
    },
    {
      type: "Feature",
      id: "sm42d05c70",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.00728539, 40.714681155],
            [-74.007536269, 40.714986537],
            [-74.008174482, 40.714685316],
            [-74.007923603, 40.714379933],
            [-74.00728539, 40.714681155],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB98",
      },
    },
    {
      type: "Feature",
      id: "sm8e60288f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.007923603, 40.714379933],
            [-74.007710482, 40.714120509],
            [-74.007106025, 40.714290944],
            [-74.007041652, 40.714384464],
            [-74.00728539, 40.714681155],
            [-74.007923603, 40.714379933],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB97",
      },
    },
    {
      type: "Feature",
      id: "smb98e3b53",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.008174482, 40.714685316],
            [-74.008928246, 40.714329557],
            [-74.008610743, 40.71394533],
            [-74.008447128, 40.713912801],
            [-74.008447128, 40.713912801],
            [-74.007710482, 40.714120509],
            [-74.008174482, 40.714685316],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB113",
      },
    },
    {
      type: "Feature",
      id: "sm1de8c327",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.011594747, 40.715244954],
            [-74.011054657, 40.715420128],
            [-74.011435406, 40.715890839],
            [-74.011767704, 40.715736421],
            [-74.011807937, 40.715622573],
            [-74.011594747, 40.715244954],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB122",
      },
    },
    {
      type: "Feature",
      id: "smea7843c8",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.010066414, 40.713464196],
            [-74.010367391, 40.713997323],
            [-74.010809444, 40.713853943],
            [-74.010558027, 40.713408602],
            [-74.010381002, 40.713376073],
            [-74.010066414, 40.713464196],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB128",
      },
    },
    {
      type: "Feature",
      id: "sm485561e8",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.010367391, 40.713997323],
            [-74.010066414, 40.713464196],
            [-74.009582269, 40.713599816],
            [-74.010000144, 40.71411644],
            [-74.010367391, 40.713997323],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB127",
      },
    },
    {
      type: "Feature",
      id: "sm2726cdb2",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.010809444, 40.713853943],
            [-74.010000144, 40.71411644],
            [-74.010231574, 40.714402558],
            [-74.010981792, 40.714159227],
            [-74.010809444, 40.713853943],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB126",
      },
    },
    {
      type: "Feature",
      id: "sm137d387c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.010981792, 40.714159227],
            [-74.010231574, 40.714402558],
            [-74.010471948, 40.714699732],
            [-74.0111608, 40.714476305],
            [-74.010981792, 40.714159227],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB125",
      },
    },
    {
      type: "Feature",
      id: "smdb51ffaf",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.0111608, 40.714476305],
            [-74.010471948, 40.714699732],
            [-74.010747295, 40.715040141],
            [-74.011365852, 40.714839515],
            [-74.0111608, 40.714476305],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB124",
      },
    },
    {
      type: "Feature",
      id: "smb6b74db9",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.011365852, 40.714839515],
            [-74.010747295, 40.715040141],
            [-74.011054657, 40.715420128],
            [-74.011594747, 40.715244954],
            [-74.011365852, 40.714839515],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB123",
      },
    },
    {
      type: "Feature",
      id: "sm6dc4efc9",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.009093183, 40.71416932],
            [-74.009783454, 40.713848544],
            [-74.009582269, 40.713599816],
            [-74.008900422, 40.713790817],
            [-74.0088736, 40.713904668],
            [-74.009093183, 40.71416932],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB114",
      },
    },
    {
      type: "Feature",
      id: "sm61c8a66d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.011191904, 40.715589804],
            [-74.010515811, 40.715903984],
            [-74.010713595, 40.716151151],
            [-74.010866481, 40.716155217],
            [-74.011435406, 40.715890839],
            [-74.011191904, 40.715589804],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB121",
      },
    },
    {
      type: "Feature",
      id: "sma2b25ae0",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.010515811, 40.715903984],
            [-74.011191904, 40.715589804],
            [-74.010953463, 40.715295023],
            [-74.010279235, 40.715608338],
            [-74.010515811, 40.715903984],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB120",
      },
    },
    {
      type: "Feature",
      id: "sm10daecf1",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.010279235, 40.715608338],
            [-74.010953463, 40.715295023],
            [-74.010711465, 40.714995844],
            [-74.010038454, 40.715308594],
            [-74.010064501, 40.715339986],
            [-74.010279235, 40.715608338],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB119",
      },
    },
    {
      type: "Feature",
      id: "sma3a1983e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.010038454, 40.715308594],
            [-74.010711465, 40.714995844],
            [-74.010480736, 40.714710595],
            [-74.009803434, 40.715025341],
            [-74.010038454, 40.715308594],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB118",
      },
    },
    {
      type: "Feature",
      id: "sm759b42d2",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.009803434, 40.715025341],
            [-74.010480736, 40.714710595],
            [-74.010243376, 40.714417148],
            [-74.009561659, 40.714733946],
            [-74.009803434, 40.715025341],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB117",
      },
    },
    {
      type: "Feature",
      id: "sm8d02f0bd",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.009561659, 40.714733946],
            [-74.010243376, 40.714417148],
            [-74.010007553, 40.714125599],
            [-74.00932145, 40.714444437],
            [-74.009561659, 40.714733946],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB116",
      },
    },
    {
      type: "Feature",
      id: "sm11880387",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.00932145, 40.714444437],
            [-74.010007553, 40.714125599],
            [-74.009783454, 40.713848544],
            [-74.009093183, 40.71416932],
            [-74.00932145, 40.714444437],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB115",
      },
    },
    {
      type: "Feature",
      id: "sm76e6a617",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.004648686, 40.720098122],
            [-74.00418962, 40.719543304],
            [-74.00390615, 40.71967828],
            [-74.00390615, 40.71967828],
            [-74.003873964, 40.719816516],
            [-74.004217286, 40.720198694],
            [-74.004394312, 40.720219023],
            [-74.004648686, 40.720098122],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB15",
      },
    },
    {
      type: "Feature",
      id: "sm3be4b6f4",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.011310313, 40.716152641],
            [-74.011773649, 40.716711628],
            [-74.012033242, 40.71658824],
            [-74.012065429, 40.716421537],
            [-74.011770386, 40.716079996],
            [-74.011539716, 40.716043403],
            [-74.011310313, 40.716152641],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB36",
      },
    },
    {
      type: "Feature",
      id: "smbb5d4858",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.011773649, 40.716711628],
            [-74.011310313, 40.716152641],
            [-74.010960344, 40.71631929],
            [-74.011423499, 40.716878058],
            [-74.011773649, 40.716711628],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB35",
      },
    },
    {
      type: "Feature",
      id: "sm863cf86f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.011423499, 40.716878058],
            [-74.010960344, 40.71631929],
            [-74.010625141, 40.716478907],
            [-74.011087519, 40.717037753],
            [-74.011423499, 40.716878058],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB34",
      },
    },
    {
      type: "Feature",
      id: "smd7223bec",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.011087519, 40.717037753],
            [-74.010625141, 40.716478907],
            [-74.010242535, 40.716661096],
            [-74.010704716, 40.717219703],
            [-74.011087519, 40.717037753],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB33",
      },
    },
    {
      type: "Feature",
      id: "sm65ddc201",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.010704716, 40.717219703],
            [-74.010242535, 40.716661096],
            [-74.009887321, 40.716830241],
            [-74.010349319, 40.717388626],
            [-74.010704716, 40.717219703],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB32",
      },
    },
    {
      type: "Feature",
      id: "sm2be908c1",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.010349319, 40.717388626],
            [-74.009887321, 40.716830241],
            [-74.00953302, 40.716998951],
            [-74.009994836, 40.717557114],
            [-74.010349319, 40.717388626],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB31",
      },
    },
    {
      type: "Feature",
      id: "sm8902b5c1",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.009994836, 40.717557114],
            [-74.00953302, 40.716998951],
            [-74.009179632, 40.717167225],
            [-74.009641267, 40.717725167],
            [-74.009994836, 40.717557114],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB30",
      },
    },
    {
      type: "Feature",
      id: "smf333a7d8",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.009641267, 40.717725167],
            [-74.009179632, 40.717167225],
            [-74.008831072, 40.717333201],
            [-74.009292527, 40.717890925],
            [-74.009641267, 40.717725167],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB29",
      },
    },
    {
      type: "Feature",
      id: "smc9d2c222",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.009292527, 40.717890925],
            [-74.008831072, 40.717333201],
            [-74.008482511, 40.717499177],
            [-74.008943787, 40.718056682],
            [-74.009292527, 40.717890925],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB28",
      },
    },
    {
      type: "Feature",
      id: "smf05ff54f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.008943787, 40.718056682],
            [-74.008482511, 40.717499177],
            [-74.008112817, 40.717675215],
            [-74.008573903, 40.718232488],
            [-74.008943787, 40.718056682],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB27",
      },
    },
    {
      type: "Feature",
      id: "sm4fcc6bc7",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.008573903, 40.718232488],
            [-74.008112817, 40.717675215],
            [-74.007752511, 40.717846782],
            [-74.008214013, 40.718403544],
            [-74.008573903, 40.718232488],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB26",
      },
    },
    {
      type: "Feature",
      id: "smc825143a",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.008214013, 40.718403544],
            [-74.007752511, 40.717846782],
            [-74.007395392, 40.718016831],
            [-74.007856711, 40.71857337],
            [-74.008214013, 40.718403544],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB25",
      },
    },
    {
      type: "Feature",
      id: "sm1ed93dfa",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.007856711, 40.71857337],
            [-74.007395392, 40.718016831],
            [-74.007049712, 40.718181433],
            [-74.007510853, 40.718737756],
            [-74.007856711, 40.71857337],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB24",
      },
    },
    {
      type: "Feature",
      id: "sma6e6ad09",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.007510853, 40.718737756],
            [-74.007049712, 40.718181433],
            [-74.006675235, 40.718359747],
            [-74.007136183, 40.718915835],
            [-74.007510853, 40.718737756],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB23",
      },
    },
    {
      type: "Feature",
      id: "sm22e7667d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.007136183, 40.718915835],
            [-74.006675235, 40.718359747],
            [-74.006319003, 40.718529373],
            [-74.006779767, 40.719085238],
            [-74.007136183, 40.718915835],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB22",
      },
    },
    {
      type: "Feature",
      id: "smdf3b24a8",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.006779767, 40.719085238],
            [-74.006319003, 40.718529373],
            [-74.005975296, 40.718693034],
            [-74.006435883, 40.719248684],
            [-74.006779767, 40.719085238],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB21",
      },
    },
    {
      type: "Feature",
      id: "sm81779afa",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.006435883, 40.719248684],
            [-74.005975296, 40.718693034],
            [-74.005617091, 40.718863598],
            [-74.006077493, 40.719419024],
            [-74.006435883, 40.719248684],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB20",
      },
    },
    {
      type: "Feature",
      id: "sm7a681901",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.006077493, 40.719419024],
            [-74.005617091, 40.718863598],
            [-74.005240977, 40.719042689],
            [-74.005700585, 40.719598165],
            [-74.006077493, 40.719419024],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB19",
      },
    },
    {
      type: "Feature",
      id: "sm84efe242",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.005700585, 40.719598165],
            [-74.005240977, 40.719042689],
            [-74.004894503, 40.719207667],
            [-74.005353932, 40.719762926],
            [-74.005700585, 40.719598165],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB18",
      },
    },
    {
      type: "Feature",
      id: "sm8659afd0",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.005353932, 40.719762926],
            [-74.004894503, 40.719207667],
            [-74.004538029, 40.719377406],
            [-74.004997875, 40.719932156],
            [-74.005353932, 40.719762926],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB17",
      },
    },
    {
      type: "Feature",
      id: "smfcd6503a",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.004997875, 40.719932156],
            [-74.004538029, 40.719377406],
            [-74.00418962, 40.719543304],
            [-74.004648686, 40.720098122],
            [-74.004997875, 40.719932156],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB16",
      },
    },
    {
      type: "Feature",
      id: "smebef6ded",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.013270084, 40.714855039],
            [-74.012541421, 40.715081876],
            [-74.01272732, 40.715424947],
            [-74.01335289, 40.715230204],
            [-74.013395805, 40.715083827],
            [-74.013270084, 40.714855039],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB136",
      },
    },
    {
      type: "Feature",
      id: "sm529d687c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.011639071, 40.713416587],
            [-74.012356865, 40.713193127],
            [-74.012231727, 40.712965393],
            [-74.012049337, 40.712900334],
            [-74.011451544, 40.713070501],
            [-74.011639071, 40.713416587],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB142",
      },
    },
    {
      type: "Feature",
      id: "sme6cde926",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.012356865, 40.713193127],
            [-74.011639071, 40.713416587],
            [-74.011825776, 40.713761154],
            [-74.012545818, 40.713536996],
            [-74.012356865, 40.713193127],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB141",
      },
    },
    {
      type: "Feature",
      id: "sm19ef8b59",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.012545818, 40.713536996],
            [-74.011825776, 40.713761154],
            [-74.011997601, 40.714078259],
            [-74.012719713, 40.713853458],
            [-74.012545818, 40.713536996],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB140",
      },
    },
    {
      type: "Feature",
      id: "smf5b15dc1",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.012719713, 40.713853458],
            [-74.011997601, 40.714078259],
            [-74.012178313, 40.714411764],
            [-74.012902602, 40.714186287],
            [-74.012719713, 40.713853458],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB139",
      },
    },
    {
      type: "Feature",
      id: "sm383b940c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.012902602, 40.714186287],
            [-74.012178313, 40.714411764],
            [-74.012356063, 40.714739801],
            [-74.013082493, 40.714513657],
            [-74.012902602, 40.714186287],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB138",
      },
    },
    {
      type: "Feature",
      id: "sm98957f68",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.013082493, 40.714513657],
            [-74.012356063, 40.714739801],
            [-74.012541421, 40.715081876],
            [-74.013270084, 40.714855039],
            [-74.013082493, 40.714513657],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB137",
      },
    },
    {
      type: "Feature",
      id: "sm14866ada",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.010932292, 40.713634583],
            [-74.011638128, 40.713414848],
            [-74.011451544, 40.713070501],
            [-74.010820885, 40.713250023],
            [-74.010783334, 40.713367941],
            [-74.010932292, 40.713634583],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB129",
      },
    },
    {
      type: "Feature",
      id: "sm136ded5d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.012541624, 40.715082249],
            [-74.011859636, 40.715294555],
            [-74.011984963, 40.71551889],
            [-74.011984963, 40.71551889],
            [-74.01215126, 40.715604276],
            [-74.01272732, 40.715424947],
            [-74.012541624, 40.715082249],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB135",
      },
    },
    {
      type: "Feature",
      id: "sm2623ff77",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.011859636, 40.715294555],
            [-74.012541624, 40.715082249],
            [-74.012355592, 40.714738931],
            [-74.011668694, 40.714952767],
            [-74.011859636, 40.715294555],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB134",
      },
    },
    {
      type: "Feature",
      id: "smdadaf5e8",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.011668694, 40.714952767],
            [-74.012355592, 40.714738931],
            [-74.012178919, 40.714412883],
            [-74.011487358, 40.714628172],
            [-74.011668694, 40.714952767],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB133",
      },
    },
    {
      type: "Feature",
      id: "sm0b00edae",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.011487358, 40.714628172],
            [-74.012178919, 40.714412883],
            [-74.01199558, 40.714074532],
            [-74.01129918, 40.714291328],
            [-74.011487358, 40.714628172],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB132",
      },
    },
    {
      type: "Feature",
      id: "smc0867886",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.01129918, 40.714291328],
            [-74.01199558, 40.714074532],
            [-74.011822611, 40.713755315],
            [-74.011121645, 40.713973533],
            [-74.01129918, 40.714291328],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB131",
      },
    },
    {
      type: "Feature",
      id: "sm6a016fb5",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.011121645, 40.713973533],
            [-74.011822611, 40.713755315],
            [-74.011638128, 40.713414848],
            [-74.010932292, 40.713634583],
            [-74.011121645, 40.713973533],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB130",
      },
    },
    {
      type: "Feature",
      id: "smee6a26ed",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.014208353, 40.713042149],
            [-74.014026496, 40.712711454],
            [-74.013291437, 40.712952822],
            [-74.01347349, 40.713274332],
            [-74.014208353, 40.713042149],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB155",
      },
    },
    {
      type: "Feature",
      id: "smf9714cef",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.01347349, 40.713274332],
            [-74.013654969, 40.713594826],
            [-74.014385375, 40.713364052],
            [-74.014208353, 40.713042149],
            [-74.01347349, 40.713274332],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB154",
      },
    },
    {
      type: "Feature",
      id: "sm022fdb57",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.013654969, 40.713594826],
            [-74.013836861, 40.713916049],
            [-74.014559626, 40.713680915],
            [-74.014385375, 40.713364052],
            [-74.013654969, 40.713594826],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB153",
      },
    },
    {
      type: "Feature",
      id: "sm917ba757",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.013836861, 40.713916049],
            [-74.014017161, 40.71423446],
            [-74.014735518, 40.71400076],
            [-74.014559626, 40.713680915],
            [-74.013836861, 40.713916049],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB152",
      },
    },
    {
      type: "Feature",
      id: "sm20362d65",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.014017161, 40.71423446],
            [-74.014201357, 40.714559748],
            [-74.014918347, 40.714333217],
            [-74.014735518, 40.71400076],
            [-74.014017161, 40.71423446],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB151",
      },
    },
    {
      type: "Feature",
      id: "smb18b30e2",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.014201357, 40.714559748],
            [-74.014392285, 40.714896924],
            [-74.01500513, 40.714697552],
            [-74.015042681, 40.714559306],
            [-74.014918347, 40.714333217],
            [-74.014201357, 40.714559748],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB150",
      },
    },
    {
      type: "Feature",
      id: "smf2a46dd3",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.013492502, 40.714799372],
            [-74.013631839, 40.715043166],
            [-74.013792772, 40.715091958],
            [-74.014392285, 40.714896924],
            [-74.014205669, 40.714567363],
            [-74.013492502, 40.714799372],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB149",
      },
    },
    {
      type: "Feature",
      id: "sm984ed590",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.014205669, 40.714567363],
            [-74.014016749, 40.714233731],
            [-74.013302096, 40.714466224],
            [-74.013492502, 40.714799372],
            [-74.014205669, 40.714567363],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB148",
      },
    },
    {
      type: "Feature",
      id: "smefff8842",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.014016749, 40.714233731],
            [-74.013839511, 40.713920729],
            [-74.013123465, 40.714153677],
            [-74.013302096, 40.714466224],
            [-74.014016749, 40.714233731],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB147",
      },
    },
    {
      type: "Feature",
      id: "sm32c3f799",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.013839511, 40.713920729],
            [-74.013654479, 40.713593961],
            [-74.012936978, 40.713827383],
            [-74.013123465, 40.714153677],
            [-74.013839511, 40.713920729],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB146",
      },
    },
    {
      type: "Feature",
      id: "sm71202091",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.013654479, 40.713593961],
            [-74.013473335, 40.713274058],
            [-74.01275441, 40.713507945],
            [-74.012936978, 40.713827383],
            [-74.013654479, 40.713593961],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB145",
      },
    },
    {
      type: "Feature",
      id: "sm5bcfaaa3",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.013473335, 40.713274058],
            [-74.013291437, 40.712952822],
            [-74.012572133, 40.713189015],
            [-74.01275441, 40.713507945],
            [-74.013473335, 40.713274058],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB144",
      },
    },
    {
      type: "Feature",
      id: "sm1e068b92",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.013079272, 40.712638377],
            [-74.012494583, 40.712798679],
            [-74.012414117, 40.712912532],
            [-74.012572133, 40.713189015],
            [-74.013264111, 40.712961794],
            [-74.013079272, 40.712638377],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB143",
      },
    },
    {
      type: "Feature",
      id: "sm9b981f2d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.013264111, 40.712961794],
            [-74.014026496, 40.712711454],
            [-74.013926882, 40.712530312],
            [-74.013926882, 40.712530312],
            [-74.013755221, 40.712453054],
            [-74.013079272, 40.712638377],
            [-74.013264111, 40.712961794],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB156",
      },
    },
    {
      type: "Feature",
      id: "sm875faa49",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.015918484, 40.712540598],
            [-74.015741763, 40.71222783],
            [-74.015008517, 40.712465631],
            [-74.015185088, 40.712778445],
            [-74.015918484, 40.712540598],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB169",
      },
    },
    {
      type: "Feature",
      id: "sm28f26c1e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.015185088, 40.712778445],
            [-74.015355754, 40.713080797],
            [-74.016089294, 40.712842903],
            [-74.015918484, 40.712540598],
            [-74.015185088, 40.712778445],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB168",
      },
    },
    {
      type: "Feature",
      id: "sm19e7146a",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.015355754, 40.713080797],
            [-74.01553198, 40.713392996],
            [-74.016265669, 40.713155055],
            [-74.016089294, 40.712842903],
            [-74.015355754, 40.713080797],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB167",
      },
    },
    {
      type: "Feature",
      id: "smb76b51a7",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.01553198, 40.713392996],
            [-74.015717089, 40.713720931],
            [-74.016450821, 40.71348274],
            [-74.016265669, 40.713155055],
            [-74.01553198, 40.713392996],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB166",
      },
    },
    {
      type: "Feature",
      id: "sm6eb4df67",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.015717089, 40.713720931],
            [-74.015887215, 40.714022321],
            [-74.01662109, 40.713784084],
            [-74.016450821, 40.71348274],
            [-74.015717089, 40.713720931],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB165",
      },
    },
    {
      type: "Feature",
      id: "sm4427a087",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.015887215, 40.714022321],
            [-74.016073062, 40.714351561],
            [-74.016711017, 40.714146599],
            [-74.016759297, 40.714028682],
            [-74.01662109, 40.713784084],
            [-74.015887215, 40.714022321],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB164",
      },
    },
    {
      type: "Feature",
      id: "sm881e230d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.015142259, 40.714264068],
            [-74.015265305, 40.714482051],
            [-74.015407462, 40.714565405],
            [-74.016073062, 40.714351561],
            [-74.015887289, 40.714022453],
            [-74.015142259, 40.714264068],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB163",
      },
    },
    {
      type: "Feature",
      id: "sm1c061136",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.015887289, 40.714022453],
            [-74.015708342, 40.713705435],
            [-74.014963312, 40.713947052],
            [-74.015142259, 40.714264068],
            [-74.015887289, 40.714022453],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB162",
      },
    },
    {
      type: "Feature",
      id: "sm1eebe91a",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.015708342, 40.713705435],
            [-74.015533487, 40.713395666],
            [-74.014788457, 40.713637283],
            [-74.014963312, 40.713947052],
            [-74.015708342, 40.713705435],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB161",
      },
    },
    {
      type: "Feature",
      id: "sm1ccb16bd",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.015533487, 40.713395666],
            [-74.015359761, 40.713087895],
            [-74.014614731, 40.713329514],
            [-74.014788457, 40.713637283],
            [-74.015533487, 40.713395666],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB160",
      },
    },
    {
      type: "Feature",
      id: "sm8263ac26",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.015359761, 40.713087895],
            [-74.015182696, 40.712774207],
            [-74.014437665, 40.713015827],
            [-74.014614731, 40.713329514],
            [-74.015359761, 40.713087895],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB159",
      },
    },
    {
      type: "Feature",
      id: "sm39ba7c04",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.015182696, 40.712774207],
            [-74.015008517, 40.712465631],
            [-74.014263486, 40.712707252],
            [-74.014437665, 40.713015827],
            [-74.015182696, 40.712774207],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB158",
      },
    },
    {
      type: "Feature",
      id: "sm3d068f6e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.014793545, 40.712158452],
            [-74.014189738, 40.712331069],
            [-74.014120001, 40.712453054],
            [-74.014263486, 40.712707252],
            [-74.014973369, 40.712477029],
            [-74.014793545, 40.712158452],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB157",
      },
    },
    {
      type: "Feature",
      id: "sm31c50a5e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.014973369, 40.712477029],
            [-74.015741763, 40.71222783],
            [-74.015622039, 40.712015937],
            [-74.015434285, 40.711975275],
            [-74.015434285, 40.711975275],
            [-74.014793545, 40.712158452],
            [-74.014973369, 40.712477029],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB170",
      },
    },
    {
      type: "Feature",
      id: "sm3579718e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.016536009, 40.711677755],
            [-74.01671483, 40.711990554],
            [-74.017524615, 40.711724567],
            [-74.017411073, 40.711525955],
            [-74.017244776, 40.711481227],
            [-74.016536009, 40.711677755],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB184",
      },
    },
    {
      type: "Feature",
      id: "sm057d1dbf",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.01671483, 40.711990554],
            [-74.016536009, 40.711677755],
            [-74.015895624, 40.711855321],
            [-74.015855391, 40.711973242],
            [-74.015995657, 40.712226777],
            [-74.01671483, 40.711990554],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB171",
      },
    },
    {
      type: "Feature",
      id: "sm4646a5d1",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.016162418, 40.712528201],
            [-74.016924058, 40.71227803],
            [-74.016752617, 40.711978142],
            [-74.015995657, 40.712226777],
            [-74.016162418, 40.712528201],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB172",
      },
    },
    {
      type: "Feature",
      id: "smade62424",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.017607079, 40.713472774],
            [-74.016826794, 40.713729064],
            [-74.01693632, 40.71392703],
            [-74.017107982, 40.714008352],
            [-74.017790191, 40.71379307],
            [-74.017607079, 40.713472774],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB177",
      },
    },
    {
      type: "Feature",
      id: "sma0015692",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.016826794, 40.713729064],
            [-74.017607079, 40.713472774],
            [-74.017437335, 40.713175858],
            [-74.016661684, 40.713430628],
            [-74.016826794, 40.713729064],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB176",
      },
    },
    {
      type: "Feature",
      id: "sm80dbb31b",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.016661684, 40.713430628],
            [-74.017437335, 40.713175858],
            [-74.017264308, 40.712873199],
            [-74.016489536, 40.713119471],
            [-74.016661684, 40.713430628],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB175",
      },
    },
    {
      type: "Feature",
      id: "sm5543afa4",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.016489536, 40.713119471],
            [-74.017264308, 40.712873199],
            [-74.017087344, 40.712563652],
            [-74.016321246, 40.712815286],
            [-74.016489536, 40.713119471],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB174",
      },
    },
    {
      type: "Feature",
      id: "sm8f914d00",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.016321246, 40.712815286],
            [-74.017087344, 40.712563652],
            [-74.016924058, 40.71227803],
            [-74.016162418, 40.712528201],
            [-74.016321246, 40.712815286],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB173",
      },
    },
    {
      type: "Feature",
      id: "sm7d9de0ce",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.018379991, 40.713220802],
            [-74.017607992, 40.713474371],
            [-74.017790191, 40.71379307],
            [-74.018422264, 40.713593609],
            [-74.018518824, 40.713491956],
            [-74.018387397, 40.713233757],
            [-74.018379991, 40.713220802],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB178",
      },
    },
    {
      type: "Feature",
      id: "sm336ea060",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.016921578, 40.712273693],
            [-74.017693576, 40.712020119],
            [-74.017524615, 40.711724567],
            [-74.016752617, 40.711978142],
            [-74.016921578, 40.712273693],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB183",
      },
    },
    {
      type: "Feature",
      id: "sm4e3dc027",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.017693576, 40.712020119],
            [-74.016921578, 40.712273693],
            [-74.017094584, 40.712576318],
            [-74.017866582, 40.712322745],
            [-74.017693576, 40.712020119],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB182",
      },
    },
    {
      type: "Feature",
      id: "smb2c1e6e5",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.017866582, 40.712322745],
            [-74.017094584, 40.712576318],
            [-74.017266938, 40.7128778],
            [-74.018038936, 40.712624229],
            [-74.017866582, 40.712322745],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB181",
      },
    },
    {
      type: "Feature",
      id: "sm041b37ca",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.018038936, 40.712624229],
            [-74.017266938, 40.7128778],
            [-74.017433812, 40.713169696],
            [-74.01820581, 40.712916126],
            [-74.018038936, 40.712624229],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB180",
      },
    },
    {
      type: "Feature",
      id: "sm46469a34",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.01820581, 40.712916126],
            [-74.017433812, 40.713169696],
            [-74.017607992, 40.713474371],
            [-74.018379991, 40.713220802],
            [-74.01820581, 40.712916126],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB179",
      },
    },
    {
      type: "Feature",
      id: "sm573646df",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.019274792, 40.711296521],
            [-74.019138416, 40.711058334],
            [-74.018934568, 40.711001406],
            [-74.018929204, 40.711001406],
            [-74.018371609, 40.711161079],
            [-74.018583744, 40.71152682],
            [-74.019274792, 40.711296521],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB197",
      },
    },
    {
      type: "Feature",
      id: "sm13c89a8a",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.018583744, 40.71152682],
            [-74.018771882, 40.711851185],
            [-74.019460899, 40.711621564],
            [-74.019274792, 40.711296521],
            [-74.018583744, 40.71152682],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB196",
      },
    },
    {
      type: "Feature",
      id: "sm67035013",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.018771882, 40.711851185],
            [-74.018960804, 40.712176899],
            [-74.019647781, 40.711947959],
            [-74.019460899, 40.711621564],
            [-74.018771882, 40.711851185],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB195",
      },
    },
    {
      type: "Feature",
      id: "smbcceefd2",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.018960804, 40.712176899],
            [-74.019160323, 40.712520884],
            [-74.019845147, 40.712292662],
            [-74.019647781, 40.711947959],
            [-74.018960804, 40.712176899],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB194",
      },
    },
    {
      type: "Feature",
      id: "sm74f615b0",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.019160323, 40.712520884],
            [-74.019351975, 40.712851303],
            [-74.02003614, 40.712626234],
            [-74.019845147, 40.712292662],
            [-74.019160323, 40.712520884],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB193",
      },
    },
    {
      type: "Feature",
      id: "sma66700b6",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.019351975, 40.712851303],
            [-74.019570038, 40.713227254],
            [-74.020136197, 40.713038581],
            [-74.020179112, 40.712875935],
            [-74.02003614, 40.712626234],
            [-74.019351975, 40.712851303],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB192",
      },
    },
    {
      type: "Feature",
      id: "sm3a4276ba",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.018606859, 40.713168309],
            [-74.018741448, 40.713396402],
            [-74.018891652, 40.713453327],
            [-74.019570038, 40.713227254],
            [-74.019385366, 40.71290887],
            [-74.018606859, 40.713168309],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB191",
      },
    },
    {
      type: "Feature",
      id: "sm1001e5fe",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.019385366, 40.71290887],
            [-74.019212563, 40.712610948],
            [-74.018431558, 40.71287122],
            [-74.018606859, 40.713168309],
            [-74.019385366, 40.71290887],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB190",
      },
    },
    {
      type: "Feature",
      id: "sm59229500",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.019212563, 40.712610948],
            [-74.019042929, 40.712318488],
            [-74.018259473, 40.712579579],
            [-74.018431558, 40.71287122],
            [-74.019212563, 40.712610948],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB189",
      },
    },
    {
      type: "Feature",
      id: "sm662887f2",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.019042929, 40.712318488],
            [-74.018863651, 40.712009401],
            [-74.018077605, 40.712271356],
            [-74.018259473, 40.712579579],
            [-74.019042929, 40.712318488],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB188",
      },
    },
    {
      type: "Feature",
      id: "sm7b2fe266",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.018863651, 40.712009401],
            [-74.018703967, 40.711734094],
            [-74.017915614, 40.711996819],
            [-74.018077605, 40.712271356],
            [-74.018863651, 40.712009401],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB187",
      },
    },
    {
      type: "Feature",
      id: "sm9458117c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.018703967, 40.711734094],
            [-74.018537809, 40.711447623],
            [-74.017747055, 40.711711149],
            [-74.017915614, 40.711996819],
            [-74.018703967, 40.711734094],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB186",
      },
    },
    {
      type: "Feature",
      id: "sma7004ac6",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.018537809, 40.711447623],
            [-74.018371609, 40.711161079],
            [-74.017722209, 40.71134704],
            [-74.017604192, 40.711469027],
            [-74.017747055, 40.711711149],
            [-74.018537809, 40.711447623],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB185",
      },
    },
    {
      type: "Feature",
      id: "sm5b05d3e4",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.021022206, 40.710783364],
            [-74.020881852, 40.710537848],
            [-74.020688733, 40.710501251],
            [-74.020688733, 40.710493119],
            [-74.020126408, 40.710660239],
            [-74.020327287, 40.711011626],
            [-74.021022206, 40.710783364],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB210",
      },
    },
    {
      type: "Feature",
      id: "sm7850cfa9",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.020327287, 40.711011626],
            [-74.020527302, 40.7113615],
            [-74.02122222, 40.711133239],
            [-74.021022206, 40.710783364],
            [-74.020327287, 40.711011626],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB209",
      },
    },
    {
      type: "Feature",
      id: "sm0c8daf37",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.020527302, 40.7113615],
            [-74.020712703, 40.71168581],
            [-74.021407621, 40.711457551],
            [-74.02122222, 40.711133239],
            [-74.020527302, 40.7113615],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB208",
      },
    },
    {
      type: "Feature",
      id: "smf86852a1",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.020712703, 40.71168581],
            [-74.02088858, 40.711993459],
            [-74.021583498, 40.711765201],
            [-74.021407621, 40.711457551],
            [-74.020712703, 40.71168581],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB207",
      },
    },
    {
      type: "Feature",
      id: "sm155622ec",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.02088858, 40.711993459],
            [-74.021079983, 40.712328265],
            [-74.0217749, 40.712100008],
            [-74.021583498, 40.711765201],
            [-74.02088858, 40.711993459],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB206",
      },
    },
    {
      type: "Feature",
      id: "smca8fd94a",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.021079983, 40.712328265],
            [-74.021279835, 40.712677848],
            [-74.021852811, 40.712489646],
            [-74.021927913, 40.712367661],
            [-74.0217749, 40.712100008],
            [-74.021079983, 40.712328265],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB205",
      },
    },
    {
      type: "Feature",
      id: "sma874653b",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.020268713, 40.712631604],
            [-74.020393689, 40.712855602],
            [-74.020565351, 40.712912529],
            [-74.021279835, 40.712677848],
            [-74.021097727, 40.712359303],
            [-74.020268713, 40.712631604],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB204",
      },
    },
    {
      type: "Feature",
      id: "sm20e0938e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.021097727, 40.712359303],
            [-74.020943576, 40.712089659],
            [-74.020114607, 40.712355395],
            [-74.020268713, 40.712631604],
            [-74.021097727, 40.712359303],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB203",
      },
    },
    {
      type: "Feature",
      id: "smb1b55bfb",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.020943576, 40.712089659],
            [-74.020777156, 40.711798554],
            [-74.019954661, 40.712068716],
            [-74.020114607, 40.712355395],
            [-74.020943576, 40.712089659],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB202",
      },
    },
    {
      type: "Feature",
      id: "smde839f39",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.020777156, 40.711798554],
            [-74.020608586, 40.711503685],
            [-74.019789518, 40.711772722],
            [-74.019954661, 40.712068716],
            [-74.020777156, 40.711798554],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB201",
      },
    },
    {
      type: "Feature",
      id: "sm9e6ba26c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.020608586, 40.711503685],
            [-74.02045515, 40.711235289],
            [-74.019639203, 40.711503303],
            [-74.019789518, 40.711772722],
            [-74.020608586, 40.711503685],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB200",
      },
    },
    {
      type: "Feature",
      id: "sm7d57a4be",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.02045515, 40.711235289],
            [-74.020285927, 40.710939277],
            [-74.019473421, 40.711206162],
            [-74.019639203, 40.711503303],
            [-74.02045515, 40.711235289],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB199",
      },
    },
    {
      type: "Feature",
      id: "sm628bea85",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.020285927, 40.710939277],
            [-74.020126408, 40.710660239],
            [-74.019471009, 40.710855019],
            [-74.019363721, 40.711009538],
            [-74.019473421, 40.711206162],
            [-74.020285927, 40.710939277],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB198",
      },
    },
    {
      type: "Feature",
      id: "sm078d5173",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.022901776, 40.710641647],
            [-74.022704313, 40.710303134],
            [-74.021972124, 40.710544276],
            [-74.022166699, 40.710883739],
            [-74.022901776, 40.710641647],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB221",
      },
    },
    {
      type: "Feature",
      id: "sm4d2159bd",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.022166699, 40.710883739],
            [-74.02233223, 40.711172528],
            [-74.023069763, 40.710929628],
            [-74.022901776, 40.710641647],
            [-74.022166699, 40.710883739],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB220",
      },
    },
    {
      type: "Feature",
      id: "sm28345b8f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.02233223, 40.711172528],
            [-74.022511229, 40.711484812],
            [-74.023251418, 40.711241038],
            [-74.023069763, 40.710929628],
            [-74.02233223, 40.711172528],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB219",
      },
    },
    {
      type: "Feature",
      id: "sm8ddf1571",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.022511229, 40.711484812],
            [-74.022702154, 40.711817901],
            [-74.023445176, 40.711573195],
            [-74.023251418, 40.711241038],
            [-74.022511229, 40.711484812],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB218",
      },
    },
    {
      type: "Feature",
      id: "sm569ff7f6",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.022702154, 40.711817901],
            [-74.022895719, 40.712155595],
            [-74.023521145, 40.711948841],
            [-74.023569425, 40.711786192],
            [-74.023445176, 40.711573195],
            [-74.022702154, 40.711817901],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB217",
      },
    },
    {
      type: "Feature",
      id: "sm1f418c68",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.021988013, 40.712054272],
            [-74.022121032, 40.712286337],
            [-74.022303422, 40.712351396],
            [-74.022895719, 40.712155595],
            [-74.022702721, 40.711818892],
            [-74.021988013, 40.712054272],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB216",
      },
    },
    {
      type: "Feature",
      id: "smd6ac3940",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.022702721, 40.711818892],
            [-74.022510607, 40.711483727],
            [-74.021795898, 40.711719108],
            [-74.021988013, 40.712054272],
            [-74.022702721, 40.711818892],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB215",
      },
    },
    {
      type: "Feature",
      id: "smbfa98c21",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.022510607, 40.711483727],
            [-74.022327174, 40.711163706],
            [-74.021612464, 40.711399088],
            [-74.021795898, 40.711719108],
            [-74.022510607, 40.711483727],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB214",
      },
    },
    {
      type: "Feature",
      id: "sm169dc1a4",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.022327174, 40.711163706],
            [-74.022143578, 40.7108434],
            [-74.021428868, 40.711078783],
            [-74.021612464, 40.711399088],
            [-74.022327174, 40.711163706],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB213",
      },
    },
    {
      type: "Feature",
      id: "smd75b75dc",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.022143578, 40.7108434],
            [-74.021972124, 40.710544276],
            [-74.021257415, 40.710779661],
            [-74.021428868, 40.711078783],
            [-74.022143578, 40.7108434],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB212",
      },
    },
    {
      type: "Feature",
      id: "sm6366e2e1",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.021747505, 40.710224171],
            [-74.021176895, 40.710383328],
            [-74.021107157, 40.710517516],
            [-74.021257415, 40.710779661],
            [-74.021937517, 40.710555674],
            [-74.021747505, 40.710224171],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB211",
      },
    },
    {
      type: "Feature",
      id: "sm016524c6",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.021937517, 40.710555674],
            [-74.022704313, 40.710303134],
            [-74.022585053, 40.710098685],
            [-74.022585053, 40.710098685],
            [-74.022416075, 40.71003769],
            [-74.021747505, 40.710224171],
            [-74.021937517, 40.710555674],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB222",
      },
    },
    {
      type: "Feature",
      id: "smab10b56f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.024600927, 40.710965351],
            [-74.023952973, 40.709578196],
            [-74.022842539, 40.709870974],
            [-74.022810353, 40.710021428],
            [-74.023532886, 40.711309568],
            [-74.023770584, 40.711733334],
            [-74.023942244, 40.711778062],
            [-74.024838102, 40.711473094],
            [-74.024600927, 40.710965351],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB225",
      },
    },
    {
      type: "Feature",
      id: "smf6a2d156",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.018914338, 40.71361307],
            [-74.018486639, 40.713750153],
            [-74.018829962, 40.714331604],
            [-74.018829962, 40.714331604],
            [-74.019242474, 40.714198843],
            [-74.018914338, 40.71361307],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB241",
      },
    },
    {
      type: "Feature",
      id: "smd9af7971",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.019242474, 40.714198843],
            [-74.019652644, 40.714066836],
            [-74.019324765, 40.713481522],
            [-74.018914338, 40.71361307],
            [-74.019242474, 40.714198843],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB240",
      },
    },
    {
      type: "Feature",
      id: "smaf1ea06c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.019652644, 40.714066836],
            [-74.020035038, 40.713943768],
            [-74.0197074, 40.713358882],
            [-74.019324765, 40.713481522],
            [-74.019652644, 40.714066836],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB239",
      },
    },
    {
      type: "Feature",
      id: "sm5b79394b",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.020035038, 40.713943768],
            [-74.020424286, 40.713818493],
            [-74.020096893, 40.713234044],
            [-74.0197074, 40.713358882],
            [-74.020035038, 40.713943768],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB238",
      },
    },
    {
      type: "Feature",
      id: "sm95d1cd58",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.020424286, 40.713818493],
            [-74.020821253, 40.713690734],
            [-74.02049411, 40.71310673],
            [-74.020096893, 40.713234044],
            [-74.020424286, 40.713818493],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB237",
      },
    },
    {
      type: "Feature",
      id: "sm7df4c9da",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.020821253, 40.713690734],
            [-74.021233659, 40.713558006],
            [-74.020906775, 40.712974464],
            [-74.02049411, 40.71310673],
            [-74.020821253, 40.713690734],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB236",
      },
    },
    {
      type: "Feature",
      id: "sm3dc63d78",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.021233659, 40.713558006],
            [-74.021630374, 40.713430328],
            [-74.02130374, 40.71284723],
            [-74.020906775, 40.712974464],
            [-74.021233659, 40.713558006],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB235",
      },
    },
    {
      type: "Feature",
      id: "sme162a267",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.021630374, 40.713430328],
            [-74.022028459, 40.713302209],
            [-74.021702076, 40.712719556],
            [-74.02130374, 40.71284723],
            [-74.021630374, 40.713430328],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB234",
      },
    },
    {
      type: "Feature",
      id: "sma317b0db",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.022028459, 40.713302209],
            [-74.022417455, 40.713177015],
            [-74.022091316, 40.712594798],
            [-74.021702076, 40.712719556],
            [-74.022028459, 40.713302209],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB233",
      },
    },
    {
      type: "Feature",
      id: "sm90f58bcb",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.022417455, 40.713177015],
            [-74.022836462, 40.713042161],
            [-74.022510587, 40.712460414],
            [-74.022091316, 40.712594798],
            [-74.022417455, 40.713177015],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB232",
      },
    },
    {
      type: "Feature",
      id: "sm0b00d7db",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.022836462, 40.713042161],
            [-74.023228199, 40.712916084],
            [-74.02290257, 40.712334776],
            [-74.022510587, 40.712460414],
            [-74.022836462, 40.713042161],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB231",
      },
    },
    {
      type: "Feature",
      id: "sm52f3420a",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.023228199, 40.712916084],
            [-74.023626284, 40.712787964],
            [-74.023300906, 40.712207101],
            [-74.02290257, 40.712334776],
            [-74.023228199, 40.712916084],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB230",
      },
    },
    {
      type: "Feature",
      id: "sm5b37e875",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.023626284, 40.712787964],
            [-74.02402437, 40.712659843],
            [-74.023699242, 40.712079426],
            [-74.023300906, 40.712207101],
            [-74.023626284, 40.712787964],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB229",
      },
    },
    {
      type: "Feature",
      id: "sm708b4056",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.02402437, 40.712659843],
            [-74.024411489, 40.712535252],
            [-74.024086604, 40.711955268],
            [-74.023699242, 40.712079426],
            [-74.02402437, 40.712659843],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB228",
      },
    },
    {
      type: "Feature",
      id: "smefd020fd",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.024411489, 40.712535252],
            [-74.024809827, 40.712407049],
            [-74.024485193, 40.711827512],
            [-74.024086604, 40.711955268],
            [-74.024411489, 40.712535252],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB227",
      },
    },
    {
      type: "Feature",
      id: "sm49313b95",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.024809827, 40.712407049],
            [-74.025197525, 40.712282271],
            [-74.024918576, 40.711688603],
            [-74.024485193, 40.711827512],
            [-74.024809827, 40.712407049],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB226",
      },
    },
    {
      type: "Feature",
      id: "sme5338bfd",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.012449417, 40.715697646],
            [-74.012102981, 40.715807575],
            [-74.012038608, 40.715962082],
            [-74.012403388, 40.716389008],
            [-74.012403388, 40.716389008],
            [-74.012769657, 40.716271606],
            [-74.012449417, 40.715697646],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB257",
      },
    },
    {
      type: "Feature",
      id: "sm1fd9f4e8",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.012769657, 40.716271606],
            [-74.013174637, 40.716141795],
            [-74.012855016, 40.715568944],
            [-74.012449417, 40.715697646],
            [-74.012769657, 40.716271606],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB256",
      },
    },
    {
      type: "Feature",
      id: "sm991bb4b4",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.013174637, 40.716141795],
            [-74.013553016, 40.716020511],
            [-74.013233973, 40.715448695],
            [-74.012855016, 40.715568944],
            [-74.013174637, 40.716141795],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB255",
      },
    },
    {
      type: "Feature",
      id: "sm41b4c035",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.013553016, 40.716020511],
            [-74.013972871, 40.715885932],
            [-74.01365447, 40.715315265],
            [-74.013233973, 40.715448695],
            [-74.013553016, 40.716020511],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB254",
      },
    },
    {
      type: "Feature",
      id: "sm36fdc66f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.013972871, 40.715885932],
            [-74.014353695, 40.715763864],
            [-74.014035876, 40.715194239],
            [-74.01365447, 40.715315265],
            [-74.013972871, 40.715885932],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB253",
      },
    },
    {
      type: "Feature",
      id: "sm3a120747",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.014353695, 40.715763864],
            [-74.014779844, 40.715627267],
            [-74.014462677, 40.715058808],
            [-74.014035876, 40.715194239],
            [-74.014353695, 40.715763864],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB252",
      },
    },
    {
      type: "Feature",
      id: "sm593581ad",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.014779844, 40.715627267],
            [-74.015171513, 40.715501722],
            [-74.014854944, 40.714934335],
            [-74.014462677, 40.715058808],
            [-74.014779844, 40.715627267],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB251",
      },
    },
    {
      type: "Feature",
      id: "sm6cd4136c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.015171513, 40.715501722],
            [-74.015561619, 40.715376678],
            [-74.015245646, 40.714810358],
            [-74.014854944, 40.714934335],
            [-74.015171513, 40.715501722],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB250",
      },
    },
    {
      type: "Feature",
      id: "sm601e2f3d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.015561619, 40.715376678],
            [-74.015964313, 40.715247598],
            [-74.015648956, 40.71468238],
            [-74.015245646, 40.714810358],
            [-74.015561619, 40.715376678],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB249",
      },
    },
    {
      type: "Feature",
      id: "sm0feeeb4f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.015964313, 40.715247598],
            [-74.016355461, 40.715122219],
            [-74.016040701, 40.714558072],
            [-74.015648956, 40.71468238],
            [-74.015964313, 40.715247598],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB248",
      },
    },
    {
      type: "Feature",
      id: "sm78f0ccc1",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.016355461, 40.715122219],
            [-74.016764992, 40.714990947],
            [-74.016450858, 40.714427921],
            [-74.016040701, 40.714558072],
            [-74.016355461, 40.715122219],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB247",
      },
    },
    {
      type: "Feature",
      id: "sm57bc6613",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.016764992, 40.714990947],
            [-74.017167346, 40.714861975],
            [-74.016853828, 40.714300051],
            [-74.016450858, 40.714427921],
            [-74.016764992, 40.714990947],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB246",
      },
    },
    {
      type: "Feature",
      id: "sm47b3ebdb",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.017167346, 40.714861975],
            [-74.017562343, 40.714735362],
            [-74.017249428, 40.714174519],
            [-74.016853828, 40.714300051],
            [-74.017167346, 40.714861975],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB245",
      },
    },
    {
      type: "Feature",
      id: "smf4e4487b",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.017562343, 40.714735362],
            [-74.017953672, 40.714609924],
            [-74.017641356, 40.714050152],
            [-74.017249428, 40.714174519],
            [-74.017562343, 40.714735362],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB244",
      },
    },
    {
      type: "Feature",
      id: "smfb0f8926",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.017953672, 40.714609924],
            [-74.018337607, 40.714486856],
            [-74.018028546, 40.713927288],
            [-74.017641356, 40.714050152],
            [-74.017953672, 40.714609924],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB243",
      },
    },
    {
      type: "Feature",
      id: "sm4375d621",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.018337607, 40.714486856],
            [-74.018752177, 40.714353968],
            [-74.018432995, 40.713798947],
            [-74.018028546, 40.713927288],
            [-74.018337607, 40.714486856],
          ],
        ],
      },
      properties: {
        Unit_Number: "CB242",
      },
    },
    {
      type: "Feature",
      id: "sm5721a904",
      geometry: {
        type: "LineString",
        coordinates: [
          [-74.001746967, 40.715610368],
          [-74.023891284, 40.709413501],
          [-74.025197525, 40.712282271],
          [-74.012403388, 40.716389008],
          [-74.012990787, 40.717155428],
        ],
      },
      properties: {
        Unit_Number: "CB",
      },
    },
    {
      type: "Feature",
      id: "sm399214f9",
      geometry: {
        type: "LineString",
        coordinates: [
          [-74.012561633, 40.716602463],
          [-74.002734019, 40.721253731],
        ],
      },
      properties: {
        Unit_Number: "CB",
      },
    },
  ],
};

export default geojsonData;
